export default "__VITE_ASSET__CCU1Rs78__"